import React, { useEffect, useState } from 'react';
import { ProductPurchase } from '@nile/banyan/src/Pages/Protected/Configuration/Pricing';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, useIntl } from 'react-intl';
import { BackgroundIcon, useActivityTracker } from '@nile/components';
import { Button, Heading } from '@superops/ui-design-system';

const sourceDescMap = {
  PAX8: 'admin.trial.purchase.page.header.pax8',
  DEFAULT: 'admin.trial.purchase.page.header.default'
};

function TrailPricingPage(props) {
  const { tabContext, user, isSuperopsUser } = props;

  const intl = useIntl();

  const isTrailExpiredUser = user?.subscriptionStatus === 'TRIAL_EXPIRED';

  const [openBuyPlans, setOpenBuyPlans] = useState(false);

  useEffect(() => {
    if (!tabContext?.customerPaymentDetail && isSuperopsUser) {
      setOpenBuyPlans(true);
    } else {
      setOpenBuyPlans(false);
    }
  }, [tabContext?.customerPaymentDetail]);

  useEffect(() => {
    if (tabContext.activeTab?.state?.openModal) {
      setOpenBuyPlans(true);
      tabContext.updateTab({
        module: 'ONBOARD',
        state: {
          openModal: false
        }
      });
    }
  }, [tabContext]);

  return (
    <>
      <ProductPurchase
        active={openBuyPlans}
        intl={intl}
        handleClose={() => {
          setOpenBuyPlans(false);
        }}
        user={user}
        isTrailExpired={isTrailExpiredUser}
      />
      <div className="flex fcol jctr actr full-height g10">
        <BackgroundIcon
          url={`url(${envConfig.imageRoot}svg/pricing-placeholder-img.png)`}
          height="200px"
          width="190px"
        />
        <Heading element="h1">
          {isSuperopsUser ? (
            <FormattedMessage
              id={
                tabContext?.customerPaymentDetail
                  ? 'app.purchase.inprogress'
                  : 'admin.trial.purchase.page.header'
              }
            />
          ) : (
            <>
              <FormattedMessage
                id={
                  sourceDescMap[user?.customer?.source?.name || 'DEFAULT'] ||
                  'admin.trial.purchase.page.header.default'
                }
              />
            </>
          )}
        </Heading>
        {isSuperopsUser && (
          <>
            {!tabContext?.customerPaymentDetail && (
              <Button
                primary
                onClick={() => {
                  setOpenBuyPlans(true);
                  useActivityTracker({
                    event: 'Inproduct purchase',
                    data: { source: 'A. Buy plan from billing page' }
                  });
                }}
              >
                <FormattedMessage id="app.pricing.buy.now" />
              </Button>
            )}
            <FormattedMessage
              id="app.pricing.purchase.question.clarification"
              values={{
                br: <br />,
                a: () => (
                  <Button plain onClick={() => window.Intercom('show')}>
                    <FormattedMessage id="admin.billing.contactsupport" />
                  </Button>
                )
              }}
            />
          </>
        )}
      </div>
    </>
  );
}

export default TrailPricingPage;
